// Cart Drawer Functionality
(function() {
  const cartDrawer = document.getElementById('cart-drawer');
  let isAddingToCart = false;


  function postCartUpdateJson(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          const err = new Error(
            (body && (body.message || body.description)) || 'Cart update error'
          );
          err.body = body;
          err.status = res.status;
          throw err;
        }
        return body;
      });
    });
  }

  function i18n(key) {
    if (!cartDrawer) return '';
    const v = cartDrawer.getAttribute('data-i18n-' + key);
    return v || '';
  }

  function getApplicableCodes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return [];
    return cart.discount_codes
      .filter(function(d) { return d && d.applicable && d.code; })
      .map(function(d) { return String(d.code).trim(); })
      .filter(Boolean);
  }

  function mergeDiscountString(cart, newCode) {
    const existing = getApplicableCodes(cart);
    const norm = String(newCode || '').trim();
    if (!norm) return '';
    const up = norm.toUpperCase();
    if (existing.some(function(c) { return c.toUpperCase() === up; })) {
      return existing.join(',');
    }
    return existing.concat([norm]).join(',');
  }

  function discountStringWithout(cart, codeToRemove) {
    const rem = String(codeToRemove || '').trim().toUpperCase();
    const remaining = getApplicableCodes(cart).filter(function(c) {
      return c.toUpperCase() !== rem;
    });
    return remaining.join(',');
  }

  function postCartDiscount(discountParam) {
    return postCartUpdateJson({ discount: discountParam });
  }

  function resolveCodeForRow(cart, appIndex) {
    const apps = cart.cart_level_discount_applications || [];
    const app = apps[appIndex];
    if (!app || app.type !== 'discount_code') return '';
    if (app.code) return String(app.code).trim();
    const codes = getApplicableCodes(cart);
    const codeApps = apps.filter(function(a) { return a && a.type === 'discount_code'; });
    const idxInCodeApps = codeApps.indexOf(app);
    if (idxInCodeApps >= 0 && idxInCodeApps < codes.length) return codes[idxInCodeApps];
    if (codes.length === 1) return codes[0];
    return '';
  }

  function augmentDiscountRemoveButtons() {
    if (!cartDrawer) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const apps = cart.cart_level_discount_applications || [];
        const rows = cartDrawer.querySelectorAll('.discount-applied[data-cart-discount-row]');
        const removeLabel = i18n('remove') || 'Remove';
        rows.forEach(function(row) {
          const slot = row.querySelector('[data-discount-remove-slot]');
          if (!slot) return;
          slot.innerHTML = '';
          const idx = parseInt(row.getAttribute('data-cart-discount-row'), 10);
          if (isNaN(idx) || !apps[idx] || apps[idx].type !== 'discount_code') return;
          const code = resolveCodeForRow(cart, idx);
          if (!code) return;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'discount-applied__remove';
          btn.setAttribute('data-discount-remove', code);
          btn.setAttribute('aria-label', removeLabel + ' (' + code + ')');
          btn.textContent = removeLabel;
          slot.appendChild(btn);
        });
      })
      .catch(function() {});
  }

  // Check if page is RTL (Arabic)
  function isRTL() {
    return document.documentElement.getAttribute('lang') === 'ar' ||
           document.documentElement.getAttribute('dir') === 'rtl';
  }

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {}
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  function updateCartDrawer() {
    const locale = document.documentElement.lang || 'en';
    const sectionUrl = '/' + locale + '?section_id=cart-drawer&_=' + Date.now();

    return fetch(sectionUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContent = doc.querySelector('.cart-drawer__content');
        const currentContent = cartDrawer.querySelector('.cart-drawer__content');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          initCartItemEvents();
          initDiscountForm();
          initCloseButton();
          augmentDiscountRemoveButtons();
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (e) {}
        } else {
          const newBody = doc.querySelector('.cart-drawer__body');
          const newFooter = doc.querySelector('.cart-drawer__footer');
          const newHeader = doc.querySelector('.cart-drawer__header h2');

          if (newBody) {
            const currentBody = cartDrawer.querySelector('.cart-drawer__body');
            if (currentBody) currentBody.innerHTML = newBody.innerHTML;
          }

          if (newFooter) {
            const currentFooter = cartDrawer.querySelector('.cart-drawer__footer');
            if (currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
          }

          if (newHeader) {
            const currentHeader = cartDrawer.querySelector('.cart-drawer__header h2');
            if (currentHeader) currentHeader.textContent = newHeader.textContent;
          }

          initCartItemEvents();
          initDiscountForm();
          initCloseButton();
          augmentDiscountRemoveButtons();
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (e) {}
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
  }

  function handleQuantityChange(key, newQuantity) {
    const pullCartUi = function () {
      updateCartDrawer();
      updateCartCount();
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {}
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQuantity }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        pullCartUi();
      })
      .catch(function (error) {
        console.error('Error updating quantity:', error);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.cart div').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  function initCartItemEvents() {
    if (!cartDrawer) return;

    const qtyButtons = cartDrawer.querySelectorAll('.qty-btn');
    const removeButtons = cartDrawer.querySelectorAll('.cart-drawer__remove');

    qtyButtons.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });

    removeButtons.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });

    cartDrawer.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = this.closest('[data-line-item-key]');
        const key = item?.dataset.lineItemKey;
        const input = item?.querySelector('.qty-input');
        let newQty;
        if (this.classList.contains('qty-trash') && typeof this.dataset.qtySet !== 'undefined') {
          newQty = parseInt(this.dataset.qtySet, 10);
        } else {
          const change = parseInt(this.dataset.qtyChange, 10) || 0;
          newQty = parseInt(input?.value || 0, 10) + change;
        }
        if (key && newQty >= 0) {
          handleQuantityChange(key, newQty);
        }
      });
    });

    cartDrawer.querySelectorAll('.cart-drawer__remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.lineKey;
        if (key) {
          handleQuantityChange(key, 0);
        }
      });
    });
  }

  function initCloseButton() {
    const closeBtn = cartDrawer?.querySelector('.cart-drawer__close');
    if (closeBtn) {
      const newCloseBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
      newCloseBtn.addEventListener('click', closeCartDrawer);
    }
  }

  function initDiscountForm() {
    const discountForm = cartDrawer?.querySelector('#cart-discount-form');

    if (discountForm) {
      const newForm = discountForm.cloneNode(true);
      discountForm.parentNode.replaceChild(newForm, discountForm);

      newForm.addEventListener('submit', function(e) {
        e.preventDefault();

        const discountInput = newForm.querySelector('#discount-code-input');
        const discountMessage = newForm.querySelector('#discount-message');
        const code = discountInput?.value.trim();

        if (!code) {
          if (discountMessage) {
            discountMessage.textContent = i18n('enter') || 'Please enter a discount code';
            discountMessage.className = 'discount-message discount-error';
            discountMessage.style.display = 'block';
          }
          return;
        }

        if (discountMessage) {
          discountMessage.textContent = i18n('applying') || 'Applying discount...';
          discountMessage.className = 'discount-message discount-success';
          discountMessage.style.display = 'block';
        }

        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            const merged = mergeDiscountString(cart, code);
            return postCartUpdateJson({ discount: merged });
          })
          .then(function () {
            if (discountMessage) {
              discountMessage.textContent = '';
              discountMessage.style.display = 'none';
            }
            if (discountInput) discountInput.value = '';
            updateCartDrawer();
            updateCartCount();
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (err) {}
          })
          .catch(function() {
            if (discountMessage) {
              discountMessage.textContent = i18n('failed') || 'That discount code could not be applied.';
              discountMessage.className = 'discount-message discount-error';
              discountMessage.style.display = 'block';
            }
          });
      });
    }
  }

  function initDiscountRemoveDelegation() {
    if (!cartDrawer || cartDrawer.dataset.discountRemoveInit === '1') return;
    cartDrawer.dataset.discountRemoveInit = '1';
    cartDrawer.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-discount-remove]');
      if (!btn || !cartDrawer.contains(btn)) return;
      e.preventDefault();
      const code = btn.getAttribute('data-discount-remove');
      if (!code) return;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          return postCartDiscount(discountStringWithout(cart, code));
        })
        .then(function() {
          updateCartDrawer();
          updateCartCount();
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (err) {}
        })
        .catch(function() {
          try {
            alert(i18n('network') || 'Something went wrong. Please try again.');
          } catch (err2) {}
        });
    });
  }

  function initDrawerToggle() {
    const closeBtn = cartDrawer?.querySelector('.cart-drawer__close');
    const overlay = cartDrawer?.querySelector('.cart-drawer__overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCartDrawer);
    }

    document.addEventListener('click', function(e) {
      const cartIcon = e.target.closest('.cart');
      if (cartIcon) {
        e.preventDefault();
        openCartDrawer();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer?.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });
  }

  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (isAddingToCart) {
        return false;
      }

      isAddingToCart = true;

      const form = e.target;
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        updateCartCount();
        updateCartDrawer();
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {}
        setTimeout(() => {
          openCartDrawer();
          isAddingToCart = false;
        }, 400);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Error adding product to cart. Please try again.');
        isAddingToCart = false;
      });

      return false;
    }
  }, true);

  cartDrawer && cartDrawer.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-notice-trigger]');
    if (trigger) {
      const tab = trigger.closest('[data-notice-tab]');
      if (tab) {
        const expanded = tab.classList.toggle('is-closed');
        trigger.setAttribute('aria-expanded', !expanded);
      }
    }
  });

  if (cartDrawer) {
    initDrawerToggle();
    initCartItemEvents();
    initDiscountForm();
    initDiscountRemoveDelegation();
    augmentDiscountRemoveButtons();
  }

  window.cartDrawer = {
    open: openCartDrawer,
    close: closeCartDrawer,
    update: function() {
      updateCartCount();
      return updateCartDrawer();
    }
  };
})();
